export default "__VITE_ASSET__CSqu08rA__"